import React from 'react'
import ModalWrapper from '../ModalWrapper'
import UpdateEmailContainer from '../../../containers/modals/account/UpdateEmailContainer'

const UpdateEmailModal = (props) => {
  const { hideModal } = props
  return (
    <div className='emailVerificationFlow-modalContainer marketing'>
      <ModalWrapper hideModal={hideModal} showModalHeader={false} modalStyle='dark'>
        <div className='emailVerificationFlow-modalContent'>
          <UpdateEmailContainer hideModal={hideModal} />
        </div>
      </ModalWrapper>
    </div>
  )
}

export default UpdateEmailModal
